import { Link } from "react-router-dom"; // Use 'to' instead of 'href'
import HeaderService from "../components/layout/header/HeaderService";
import Footer1 from "../components/layout/footer/Footer1";


export default function ServicePage() {
    return (
        <>
        <HeaderService />
            <section className="service-1-section">+
                <div className="auto-container">
                    <div className="section_heading text-center mb_90">
                        <span className="section_heading_title_small">What We Offers</span>
                        <h2 className="section_heading_title_big">Everyone Deserves Our <br /> Best Services</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-6"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/basic-needs.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Our assistance is for everyday life itself</h4>
                                <p className="service-1-text">Our job is to ensure that completing crucial everyday activities such as hygiene, dressing, communications and lifestyle support is never a burden for you. Enjoy the best general personal care and support, where the “easiest” tasks in daily life are properly assisted, supervised, and made a lot more convenient for you.</p>
                             
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-7"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/assisted-living.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Empowering daily care and life skills development</h4>
                                <p className="service-1-text">The support services funded by NDIS plan budgets, based on the type of assistance you choose to receive from your support worker. Your support worker will be your dependable friend, helping you work up on learning about public transport, resumes, taxes, saving, social and physical skills. Expect to enter your desired life of independence, where your daily activities are supervised in the most convenient way. </p>
                               
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/elderly.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Live together, thrive with support</h4>
                                <p className="service-1-text">Choose from a plethora of shared-living arrangements including SIL, STA, MTA and ILO. Own your independence and expect all aspects of individual care (hygiene requirements and other daily supports or respite care) regularly provided as you surround yourself with your community. Let companionship warm your soul, as you make new friends or share a cup of tea with an old one. </p>
                                
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    
                                    src="assets/images/ServiceImages/social-care.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Fun, innovative community activities are part of the package</h4>
                                <p className="service-1-text">Await chances to join local community organizations. Prepare to take part in various social, recreational and skill-building community activities, events and workshops that build rapport and boost your confidence.</p>
                                
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/game.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">We help you with socializing opportunities</h4>
                                <p className="service-1-text">Game nights, community picnics, seasonal fairs, or whichever community event or activity within a group or center you may wish you were a part of, you have only to tell our support workers, who would in turn be allowed to facilitate your participation in the events. </p>
                                
                            </div>
                        </div>
                     
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    
                                    src="assets/images/ServiceImages/broom.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">We assist you around your own household</h4>
                                <p className="service-1-text">Our services do not stop at your front door. Our participants delight in the assistance they are provided with for daily household tasks, not limited to cleaning, gardening, basic indoor and outdoor home maintenance. We will help you with the linens and laundry and be happy to whip up a meal with you. </p>
                                
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/home-address.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Leave your travel arrangements for us to fulfil</h4>
                                <p className="service-1-text">Take advantage of travel/transport arrangements featuring safety and comfort as you go from A to B.</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    )
}